export const OIDC_ID_TOKEN_PROPERTIES = [
    "iss",
    "sub",
    "aud",
    "exp",
    "iat",
    "auth_time",
    "nonce",
    "acr",
    "amr",
    "azp",
    "jti",
    "typ",
    "session_state",
    "sid",
    "at_hash",
];
export function getUserInfoFromIdToken(jwt) {
    if (!jwt)
        return undefined;
    return Object.fromEntries(Object.entries(jwt).filter(([key]) => {
        return !OIDC_ID_TOKEN_PROPERTIES.includes(key);
    }));
}
//# sourceMappingURL=getUserInfoFromIdToken.js.map